<ng-template #exhibitorDetailContainer></ng-template>
